module.exports = __webpack_public_path__ + "img/icon-geren.92a5590a.svg";